import { HealthActionTypes, HealthActions } from './types';
import { CreateProfileResult } from '../../models/profile';

const initialState: CreateProfileResult = {
  owner: '',
  name: {
    lastName: '',
    firstName: 'string',
  },
  root: '',
  profileId: '',
  datetime: '',
  active: false,
  health: {
    dob: '',
    gender: '',
    ethnicity: '',
  },
  email: {
    name: '',
    primary: false,
    detail: {
      email: '',
    },
  },
  preference: { language: '', },
};

const healthReducers = (state = initialState, action: HealthActions) => {
  switch (action.type) {
    case HealthActionTypes.ACTION_HEALTH_INIT:
      return {
        ...state,
        healthId: action.payload.healthId,
        gender: action.payload.gender,
        dob: action.payload.dob,
        ethnicity: action.payload.ethnicity,
      };
    case HealthActionTypes.ACTION_BASIC_HEALTH_SUBMIT_SUCCESS:
      return {
        ...state,
        owner: action.payload.owner,
        name: action.payload.name,
        root: action.payload.root,
        profileId: action.payload.profileId,
        datetime: action.payload.datetime,
        active: action.payload.active,
        health: action.payload.health,
        email: action.payload.email,
        preference: action.payload.preference,
      };
    case HealthActionTypes.ACTION_BASIC_HEALTH_SUBMIT_ERROR:
      return {
        ...state,
        error: action.error,
      };
  }
  return state;
};

export default healthReducers;